import BidsSortableList from "components/bids/bidsSortableList";
import Loader from "components/shared/loader";
import { paths } from "helpers/paths";
import upperFirst from "lodash/upperFirst";
import React from "react";
import Item from "./item";

export default class SuitableDistributionBidsList extends BidsSortableList {
    componentDidMount() {
        this.getList(this.props);
    }

    componentDidUpdate() {
        return undefined;
    }

    componentWillUnmount() {
        return undefined;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.shouldUpdate && !nextProps.isLoadingList) {
            this.getList(nextProps);
        }
    }

    getList = ({ getList, params }) => {
        getList({ carId: this.props.carInfo.carId, ...params });
    };

    openNewBidForm = (id) => {
        window.open(`${paths.bidNew}?distributionBidId=${id}&carId=${this.props.carInfo.carId}`, "_blank");
    };

    renderRow = (item, index) => {
        const { params, organization } = this.props;
        return <Item key={item.id} openNewBidForm={this.openNewBidForm} {...{ item, index, params, organization }} />;
    };

    thead = () => {
        return (
            <thead className="thead-light">
                <tr className="b-table__header">
                    <th>#</th>
                    <th className={this.headerClass("from")}>{this.sortableDropdHeader("from", "Начало")}</th>
                    <th className={this.headerClass("to")}>{this.sortableDropdHeader("to", "Конец")}</th>
                    <th>Порожний пробег, км</th>
                    <th>{upperFirst(this.props.organization?.currencyData?.name)}/км с порожним</th>
                    <th>Стоимость, контрагент</th>
                    <th>Автор</th>
                    <th />
                </tr>
            </thead>
        );
    };

    tbody = () => {
        const { items } = this.props;
        return items && items.length ? (
            items.map(this.renderRow)
        ) : (
            <tr>
                <td colSpan={8} className="text-center">
                    Не найдено
                </td>
            </tr>
        );
    };

    table = () => {
        const { isLoadingList } = this.props;
        if (isLoadingList) {
            return <Loader prefix="absolute-center" />;
        }
        return (
            <table className="table table-hover table-clickable table-sm">
                {this.thead()}
                <tbody>{this.tbody()}</tbody>
            </table>
        );
    };

    render() {
        return (
            <div className="list__body">
                <div className="overflow-auto" style={{ height: "100%" }}>
                    <div className="table-responsive content-wrapper">{this.table()}</div>
                </div>
            </div>
        );
    }
}
